export default __webpack_public_path__ + "static/mario-742b5edf86e02dea1ae98674276356fc.jpg";